// extracted by mini-css-extract-plugin
export default {"collapsedMenuListWrap":"brand-global-nav-menus-CollapsedMenu__collapsedMenuListWrap--3nP89","moreIcon":"brand-global-nav-menus-CollapsedMenu__moreIcon--2JTiD"};